/* eslint-disable */
import * as types from './action_types';
import TackAiChatService from '../../services/tack_ai_chat_service';

export const resetChat = () => ({
  type: types.YAK_CHAT_RESET
});

export const addUserMessage = (userMessage) => ({
  type: types.YAK_CHAT_ADD_USER,
  userMessage
});

export const addAiMessage = (aiResponseMessage) => ({
  type: types.YAK_CHAT_ADD_AI,
  aiResponseMessage
});

export const yakChatLoading = () => ({
  type: types.YAK_CHAT_LOADING
});

export const yakChatSuccess = (aiResponseMessage, userMessage, accuracy, isChatSessionComplete, guessesRemaining, guessesSoFar) => ({
  type: types.YAK_CHAT_SUCCESS,
  aiResponseMessage,
  userMessage,
  accuracy,
  isChatSessionComplete,
  guessesRemaining,
  guessesSoFar
});

export const yakChatError = (error) => ({
  type: types.YAK_CHAT_ERROR,
  error
});

export const sendYakMessage = (tackSlug, userMessage) => {
  return async (dispatch) => {
    dispatch(addUserMessage(userMessage));
    dispatch(yakChatLoading());
    try {
      const json_payload = await TackAiChatService.chat(tackSlug, userMessage);
      dispatch(yakChatSuccess(
        json_payload.ai_response_message,
        json_payload.user_message,
        json_payload.user_message_definition_accuracy,
        json_payload.is_chat_session_complete,
        json_payload.guesses_remaining,
        json_payload.guesses_so_far
      ));
    } catch (e) {
      dispatch(yakChatError(e.message || 'Chat error'));
    }
  };
}; 


// WEBPACK FOOTER //
// ./src/stores/tack_ai_chat/actions.js